import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { dashboardPathFor } from "@/lib/uiConstants";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(identifier, password);
      nav(dashboardPathFor(u));
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid md:grid-cols-2">
      <div className="hidden md:block relative" style={{ background: "var(--ink)" }}>
        <div className="absolute inset-0 p-12 flex flex-col justify-between text-white">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-md flex items-center justify-center bg-white">
              <span className="font-extrabold" style={{ color: "var(--gold)" }}>S</span>
            </span>
            <span className="font-extrabold">Sonote™</span>
          </div>
          <div>
            <h2 className="text-3xl font-bold">Welcome back.</h2>
            <p className="mt-3 text-zinc-300 max-w-md">Track today&apos;s session, follow your protocol and keep scanning&mdash;pain free.</p>
          </div>
          <p className="text-xs text-zinc-500">© Sonote {new Date().getFullYear()}</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-5" data-testid="login-form">
          <h1 className="text-3xl font-bold">Log in</h1>
          <p className="text-zinc-600 text-sm">Welcome back. Enter your credentials.</p>

          <button type="button" onClick={googleLogin} className="btn-outline w-full" data-testid="login-google-btn">
            Continue with Google
          </button>
          <div className="flex items-center gap-3 text-xs text-zinc-400">
            <span className="flex-1 border-t border-zinc-200" />OR<span className="flex-1 border-t border-zinc-200" />
          </div>

          <div>
            <label className="text-sm font-semibold">Username</label>
            <input
              type="text"
              required
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              className="mt-2 w-full h-12 rounded-md border border-zinc-200 px-4 focus:ring-2 focus:ring-[#d4af37] outline-none"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              data-testid="login-email"
              placeholder="your_username"
            />
          </div>
          <div>
            <label className="text-sm font-semibold">Password</label>
            <input type="password" required className="mt-2 w-full h-12 rounded-md border border-zinc-200 px-4 focus:ring-2 focus:ring-[#d4af37] outline-none" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
          <button disabled={busy} className="btn-gold w-full" data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</button>
          <div className="text-sm text-zinc-600">
            New to Sonote? <Link to="/register" className="font-semibold" style={{ color: "var(--gold-hover)" }}>Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
